import React from "react";
import { Button, TextField, IconButton, Typography } from "@material-ui/core";
import Delete from "@material-ui/icons/Delete";

export function normalizeRedesSociales(raw) {
  if (!Array.isArray(raw)) return [];
  return raw
    .map((r) => ({
      url: typeof r === "string" ? String(r).trim() : String(r?.url || "").trim(),
    }))
    .filter((r) => r.url);
}

export default function CongresoRedesSocialesEditor({
  redesSociales = [],
  onChange,
  caption = "Redes sociales del ponente (URL; en la web se elige el icono según el enlace)",
  className = "",
}) {
  const list = Array.isArray(redesSociales) ? redesSociales : [];

  const setUrl = (ri, val) => {
    const next = [...list];
    next[ri] = { ...(next[ri] || {}), url: val };
    onChange(next);
  };

  const add = () => onChange([...list, { url: "" }]);

  const remove = (ri) => {
    const next = [...list];
    next.splice(ri, 1);
    onChange(next);
  };

  return (
    <div className={`congreso-edicion-comite-miembro-redes ${className}`.trim()}>
      <Typography
        variant="caption"
        color="textSecondary"
        component="p"
        className="congreso-edicion-comite-miembro-redes__caption"
      >
        {caption}
      </Typography>
      {list.map((red, ri) => (
        <div key={ri} className="congreso-edicion-comite-miembro-redes__row">
          <TextField
            label="URL"
            size="small"
            fullWidth
            variant="outlined"
            margin="dense"
            placeholder="https://linkedin.com/in/…"
            value={red.url || ""}
            onChange={(e) => setUrl(ri, e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
          <IconButton
            size="small"
            onClick={() => remove(ri)}
            aria-label="Quitar enlace"
            className="congreso-edicion-comite-miembro-redes__del"
          >
            <Delete fontSize="small" />
          </IconButton>
        </div>
      ))}
      <Button
        size="small"
        variant="outlined"
        onClick={add}
        className="congreso-edicion-btn-orange congreso-edicion-comite-miembro-redes__add"
      >
        Añadir red
      </Button>
    </div>
  );
}
